import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useMainContext } from "../../../Context";
import { useQuery } from "../../../Hooks";
import {
  createAds,
  listAds,
  nesdata,
  updateAds,
  adsShow,
  payOrPulished,
  checkOffer,
} from "../../../Utils/Apis";
export const useCreateAds = () => {
  const [form, setForm] = useState({
    show: false,
    selected: {},
    step: "selectCategory",
    id: 1,
    type: "",
    option: [],
    status: false,
  });
  const navigate = useNavigate();
  const [init, setInint] = useState({});
  const [loading, setLoading] = useState({
    get: true,
    show: true,
    published: false,
  });
  const [loadingCheck, setLoadingCheck] = useState(false);

  const {
    post,
    state: { user },
  } = useMainContext();
  const { changeObj, searchParams } = useQuery({
    filters: [{ key: "ads_id" }],
  });
  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const value = key => {
    return key ? form[key] || "" : "";
  };
  const getCategory = async () => {
    setLoading({ get: true });
    const { data, status } = await post(nesdata, {
      needkey: ["categories", "options"],
    });
    setInint(data);
    setLoading({ get: false });
  };
  const store = async () => {
    setLoading({ step1: true });
    const { data, status } = await post(createAds, {
      ...form,
      category_id: form.selected.id,
    });
    if (+status === 200) {
      changeObj("ads_id", data.id);
      setForm({ ...form, ...data, step: 2 });
    }
    else {
      toast.error("لطفا مشخصات را کامل ثبت کنید");
    }
    setLoading({ step1: false });
  };
  const edit = async () => {
    if (!checkStep()) {
      return
    }

    setLoading({ edit: true });
    const { data, status } = await post(
      updateAds,
      {
        ...form,
        id: searchParams.get("ads_id"),
      },
      true
    );
    if (+status == 200) {
      if (data.ads) {
        setForm({
          ...form,
          step: +form.step + 1,
          ...data.ads,
          total_price: data.total_price,
          selected: {},
        });
      } else {
      }
    }
    setLoading({ edit: false });
  };

  const checkStep = () => {
    if (form.step == 2) {
      if (!form.province_id || !form.province_id || !form.addres) {
        toast.error("لطفا مشخصات مکانی را کامل ثبت کنید");
        return false;
      }
    }
    else if (form.step == 3) {
      if (!form.main_image) {
        toast.error("لطفا عکس اصلی را انتخاب کنید");
        return false;
      }
    }
    else if (form.step == 4) {
      if (form.type == "personal") {
        if (!form.fullname || !form.mobile || !form.email) {
          toast.error("لطفا اطلاعات تماس را کامل ثبت کنید");
          return false;
        }
      }
      else if (form.type == "company") {
        if (!form.co_addres || !form.co_mobile
          || !form.co_name || !form.co_tell) {
          toast.error("لطفا اطلاعات تماس را کامل ثبت کنید");
          return false;
        }
      }
    }

    return true;
  }

  const publised = async () => {
    setLoading({ published: true });
    const { data, status } = await post(
      payOrPulished,
      {
        ...form,
        id: searchParams.get("ads_id"),
      },
      true
    );
    if (+status == 200) {
      if (data.need_pey === "true") {
        window.location.replace(data.url);
      } else {
        return navigate("/my-ads");
      }
    }
    setLoading({ edit: false });
  };
  const show = async () => {
    setLoading({ ...loading, show: false });
    const { data, status } = await post(adsShow, {
      id: searchParams.get("ads_id"),
    });
    if (+status == 200) {
      setForm({ ...form, ...data, keywords: data.keywords || [] });
    }
  };

  useEffect(() => {
    if (searchParams.get("ads_id")) {
      show();
    }
  }, [searchParams]);

  useEffect(() => {
    getCategory();
  }, []);
  const renderTotoalPrice = (options = []) => {
    let res = 0;
    if (form.option && Array.isArray(form.option)) {
      options.map(op => {
        if (form.option.includes(op.id)) {
          res += +op.price;
        }
      });
    }
    return res;
  };
  const check = async init => {
    setLoadingCheck(true);
    const { data, status } = await post(
      checkOffer,
      {
        options: form.option,
        ads_id: searchParams.get("ads_id"),
        off_code: form.off_code,
      },
      true
    );
    setForm({ ...form, ...data, status: true });
    setLoadingCheck(false);
  };
  return {
    form,
    getCategory,
    init,
    loading,
    handler,
    store,
    edit,
    value,
    setForm,
    user,
    publised,
    searchParams,
    renderTotoalPrice,
    check,
  };
};
export const useListAds = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const { post } = useMainContext();
  const { searchParams, createObjFilter } = useQuery({});
  const get = async () => {
    setLoading(true);
    const { data } = await post(listAds, { ...createObjFilter() });
    setData(data);
    setLoading(false);
  };
  useEffect(() => {
    get();
  }, [searchParams]);

  return {
    loading,
    data,
    searchParams,
  };
};
export const useSingle = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState({ show: true, savebtn: false });
  const [error, setError] = useState({ status: false });

  const { id } = useParams();
  const {
    post,
    state: { user },
  } = useMainContext();

  const show = async () => {
    setLoading({ ...loading, show: true });
    const { data } = await post(adsShow, { id });
    setForm({ ...data, type: data.type || "personal" });

    console.log(data);
    setLoading({ ...loading, show: false });
  };

  useEffect(() => {
    show();
  }, []);

  const saveChange = async () => {
    setLoading({ ...loading, savebtn: true });
    const { status, data } = await post(updateAds, { ...form }, true);
    setForm({ ...form, ...data, type: data.type || "personal" });
    setLoading({ ...loading, savebtn: false });
  };

  const renderStatus = status => {
    switch (status) {
      case "draft":
        return {
          title: "پیش نویس",
          status: "process",
          edit: true,
        };
      case "peyerror":
        return {
          title: "عدم پرداخت",
          edit: false,
          status: "error",
        };
      case "inprocess":
        return {
          title: "در حال بررسی اولیه",
          edit: false,
          status: "process",
        };
      case "visible":
        return {
          title: "منتشر شده",
          status: "success",
          edit: true,
          buyPlan: true,
        };
      case "edited":
        return {
          buyPlan: true,
        };
      case "hidden":
        return {
          title: "غیر فعال",
          status: "error",
          edit: false,
        };
      case "reject":
        return {
          title: "رد شده",
          status: "error",
          edit: true,
        };
    }
    return {};
  };
  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const value = (key, nested = "") => {
    if (nested === "") {
      return key ? form[key] || "" : "";
    } else {
      return key ? form[nested][key] || "" : "";
    }
  };
  const validate = key => {
    let res = true;
    if (key) {
      if (key == "keywords") {
        if (form.keywords?.length == 0) {
          res = false;
        }
      } else {
        if (!form[key] || form[key] == "false") {
          res = false;
        }
      }
    } else {
      [
        "title",
        "description",
        "model",
        "addres",
        "main_image",
        "product_images",
        "keywords",
        "type",
        "price",
      ].map(key => {
        if (key == "price") {
          if (!form.tava) {
            if (!form[key]) {
              res = false;
            }
          }
        } else {
          if (!form[key]) {
            res = false;
          }
        }
      });
    }

    return res;
  };

  const publish = async () => {
    setLoading({ ...loading, publish: true });
    const { status, data } = await post(payOrPulished, { ...form }, true);
    setForm({ ...form, ...data, type: data.type || "personal" });
    setLoading({ ...loading, publish: false });
  };
  const publishHandler = () => {
    // console.log("va", validate());
    if (validate()) {
      publish();
    } else {
      setError({ status: true });
    }
  };
  return {
    form,
    setForm,
    loading,
    renderStatus,
    user,
    handler,
    value,
    saveChange,
    publish,
    error,
    publishHandler,
    validate,
  };
};
